/**
 * Product carousel — 4-up desktop / peek mobile, circular arrow controls.
 */
class DtcProductCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.dtc-product-carousel__track');
    this.wrap = this.querySelector('.dtc-product-carousel__track-wrap');
    this.prevBtn = this.querySelector('[name="previous"]');
    this.nextBtn = this.querySelector('[name="next"]');
    if (!this.track || !this.wrap) return;

    this.onPrev = () => this.scrollByPage(-1);
    this.onNext = () => this.scrollByPage(1);
    this.onScroll = () => this.updateArrows();
    this.onResize = () => this.updateArrows();

    this.prevBtn?.addEventListener('click', this.onPrev);
    this.nextBtn?.addEventListener('click', this.onNext);
    this.wrap.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);

    this.updateArrows();
    requestAnimationFrame(() => this.updateArrows());
  }

  disconnectedCallback() {
    this.prevBtn?.removeEventListener('click', this.onPrev);
    this.nextBtn?.removeEventListener('click', this.onNext);
    this.wrap?.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
  }

  getStep() {
    const cell = this.track.querySelector('.dtc-product-carousel__cell');
    if (!cell) return this.wrap.clientWidth;
    const cellWidth = cell.getBoundingClientRect().width;
    const styles = window.getComputedStyle(this.track);
    const gap = parseFloat(styles.columnGap || styles.gap) || 0;
    const visible = Math.max(1, Math.floor((this.wrap.clientWidth + gap) / (cellWidth + gap)));
    return (cellWidth + gap) * visible;
  }

  scrollByPage(direction) {
    this.wrap.scrollBy({
      left: direction * this.getStep(),
      behavior: 'smooth',
    });
  }

  updateArrows() {
    if (!this.wrap) return;
    const maxScroll = this.wrap.scrollWidth - this.wrap.clientWidth - 2;
    const atStart = this.wrap.scrollLeft <= 2;
    const atEnd = this.wrap.scrollLeft >= maxScroll;
    const needsArrows = this.wrap.scrollWidth > this.wrap.clientWidth + 4;

    if (this.prevBtn) {
      this.prevBtn.disabled = atStart;
      this.prevBtn.classList.toggle('is-disabled', atStart);
    }
    if (this.nextBtn) {
      this.nextBtn.disabled = atEnd;
      this.nextBtn.classList.toggle('is-disabled', atEnd);
    }

    this.classList.toggle('dtc-product-carousel--has-arrows', needsArrows);
  }
}

if (!customElements.get('dtc-product-carousel')) {
  customElements.define('dtc-product-carousel', DtcProductCarousel);
}
